import { render, staticRenderFns } from "./ArchiveMembersModal.vue?vue&type=template&id=40534b7e"
import script from "./ArchiveMembersModal.vue?vue&type=script&lang=js"
export * from "./ArchiveMembersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports